import { gql } from 'apollo-boost';

export const DELETE_GROUP_GQL = gql`
  mutation GroupDelete($groupId: ID!) {
    group_delete(input: { id: $groupId }) {
      message
    }
  }
`;
